import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const SinkCustomerReceivableMaster = createSlice({
  name: "SinkCustomerReceivableMaster",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    sink_customer_receivable_master: (state, action?: any) => {
      state.isLoading = true;
    },
    success_api_call_sink_customer_receivable_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_sink_customer_receivable_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    sink_customer_receivable_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
  },
});
export default SinkCustomerReceivableMaster.reducer;
export const {
  sink_customer_receivable_master,
  success_api_call_sink_customer_receivable_master,
  sink_customer_receivable_isSuccess,
  failure_api_call_sink_customer_receivable_master,
} = SinkCustomerReceivableMaster.actions;
